import { combineReducers, createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import usersReducer from 'service/users/reducer';
import loaderReducer from 'service/loader/reducer';
import notificationReducer from 'service/notifications/reducer';
import appConfigurationReducer from 'service/appconfiguration/reducer';
import dashboardReducer from 'service/dashboard/reducer';
import sourceConfigurationReducer from 'service/sourceconfiguration/reducer';
import viewConfigurationReducer from '../service/viewconfiguration/reducer';
import ddConfigurationReducer from 'service/ddconfiguration/reducer';
import tradeExplorerReducer from 'service/tradeexplorer/reducer';
import reconConfigurationReducer from 'service/reconconfiguration/reducer';
import matchingRulesReducer from 'service/matchingrules/reducer';
import matchingRulesNamesReducer from 'service/matchingrulenames/reducer';
import transactionReducer from 'service/transactions/reducer';
import defaultConfigurationReducer from 'service/defaultconfiguration/reducer';
import sourceExplorerReducer from 'service/sourceexplorer/reducer';
import reconExplorerReducer from 'service/reconexplorer/reducer';
import calculationReducer from 'service/calculationboard/reducer';
import eventConfigurationReducer from 'service/eventconfiguration/reducer';
import reportConfigurationReducer from 'service/reportconfiguration/reducer';
import reconFilterReducer from 'service/reconfilter/reducer';
import sidebarReducer from '../service/sidebar/reducer';
import themeReducer from '../service/theme/reducer';
import projectReducer from '../service/projectShifter/reducer';
import gqlReducer from '../service/graphql/reducer';
import refDataReducer from 'service/refdata';
import adjustmentConfigurationReducer from '../service/adjustmentconfiguration/reducer';
import infiniteTablePropertiesReducer from '../service/infinitetableproperties/reducer';

const reducer = combineReducers({
    refDataReducer,
    usersReducer,
    notificationReducer,
    loaderReducer,
    appConfigurationReducer,
    dashboardReducer,
    sourceConfigurationReducer,
    viewConfigurationReducer,
    ddConfigurationReducer,
    tradeExplorerReducer,
    reconConfigurationReducer,
    matchingRulesReducer,
    matchingRulesNamesReducer,
    transactionReducer,
    defaultConfigurationReducer,
    sourceExplorerReducer,
    reconExplorerReducer,
    calculationReducer,
    eventConfigurationReducer,
    reconFilterReducer,
    reportConfigurationReducer,
    gqlReducer,
    sidebarReducer,
    themeReducer,
    projectReducer,
    adjustmentConfigurationReducer,
    infiniteTablePropertiesReducer,
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(reducer, composeEnhancers(applyMiddleware(thunk)));

export default store;


